(function () {
  if (window.__cartFetchPatched) return;
  window.__cartFetchPatched = true;

  if (typeof window.fetch !== 'function') return;

  const CART_ACTIONS = ['add', 'update', 'change', 'clear'];

  const originalFetch = window.fetch;

  window.fetch = function (...args) {
    const request = args[0];
    const url = typeof request === 'string' ? request : request.url;

    const response = originalFetch.apply(this, args);

    if (url && CART_ACTIONS.some(action => url.includes(`/cart/${action}`))) {
      response.then(() => {
        document.dispatchEvent(
          new CustomEvent('cart:updated', {
            detail: { url }
          })
        );
      });
    }

    return response;
  };
})();


// Basic A/B Test Template (optimized + IIFE)
(function () {

    const HYPOTHESIS_ID = '019ae9ae-df22-7a66-b94d-d723ad5996cb';

    const updateCartAttribute = (value) =>
        fetch('/cart/update.json', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                attributes: { hypothesis: value }
            })
        });

    async function init() {
        if (!window.shoplift) {
            console.warn('Shoplift not available');
            return updateCartAttribute('');
        }

        try {
            const isActive = await window.shoplift.isHypothesisActive(HYPOTHESIS_ID);
            console.log('Hypothesis active:', isActive);
            return updateCartAttribute(isActive ? HYPOTHESIS_ID : '');
        } catch (err) {
            console.error('Test failed:', err);
            return updateCartAttribute('');
        }
    }
    init();
})();